import AssociationSchools from './AssociationSchools.page';

export default AssociationSchools;